import { useContext, useEffect, useState } from 'react';
import { IntroContext } from '@components/Intro/Intro';

export interface UseIntroStateReturnType {
  showAnimation: boolean;
}

const useIntroState = (num: number): UseIntroStateReturnType => {
  const { activeStep } = useContext(IntroContext);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    setShowAnimation(num === activeStep);
  }, [num, activeStep]);

  return { showAnimation };
};

export { useIntroState };
